import ListView from "./ListView/ListView";

const HistoryHarvest = () => <p>HistoryHarvest</p>;

HistoryHarvest.ListView = ListView;
export default HistoryHarvest;
